import down from 'icons/down.svg';
import up from 'icons/up.svg';
import './chatSettings.model';
import './chatSettings.scss';

export const ChatSettingsTemplate = (model) => {
	const { optionsData } = model;
	const OptionHtml = (option) =>
		/* html */
		`<li
                id=${option.id}
                class="engt-menu-option-list" 
                tabindex="0"
								data-active-click="false">
                    <div 
												class="engt-menu-option-name" 
												onkeydown="ENGT_CHAT.onEnterPress()"
										>
										  <span>${option.title}</span>
										  <img src="${down}" class="engt-menu-down" loader="lazy">
										  <img src="${up}" class="engt-menu-up" loader="lazy">
										</div>
										<div class="engt-option-tab" id="${option.id}Tab"></div>				
            </li>
    `;

	const getMenuOptions = (allOptions = []) => {
		let allOptionsHtml = '';
		allOptions.map((opt) => (allOptionsHtml += OptionHtml(opt)));
		return allOptionsHtml;
	};

	const allMenuHTML = getMenuOptions(optionsData);

	/* html */
	const html = `
		<header></header>
		<ul class="engt-chat-settings-options" id="chatSettingOptions">
			${allMenuHTML}
		</ul>
	`;

	return html;
};
